import apiClient from './api';
import { Praxis, AppType } from '../types';

export const praxisService = {
  getAllPraxen: async (app?: AppType): Promise<Praxis[]> => {
    const params = app ? { app } : {};
    const response = await apiClient.get('/praxen', { params });
    return response.data;
  },

  getPraxisById: async (id: number): Promise<Praxis> => {
    const response = await apiClient.get(`/praxen/${id}`);
    return response.data;
  },

  createPraxis: async (praxis: Omit<Praxis, 'id' | 'createdAt' | 'updatedAt'>): Promise<Praxis> => {
    const response = await apiClient.post('/praxen', praxis);
    return response.data;
  },

  updatePraxis: async (id: number, praxis: Partial<Omit<Praxis, 'id' | 'createdAt' | 'updatedAt'>>): Promise<Praxis> => {
    const response = await apiClient.put(`/praxen/${id}`, praxis);
    return response.data;
  },

  deletePraxis: async (id: number): Promise<void> => {
    await apiClient.delete(`/praxen/${id}`);
  },

  getPraxisZuweisungen: async (id: number) => {
    const response = await apiClient.get(`/praxen/${id}/zuweisungen`);
    return response.data;
  },
};
